import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 40px;
  }
`;
